<template>
	<section
		class="flex min-h-screen w-full flex-col items-center justify-center gap-16 bg-blue-grey-50 px-6 py-12 text-center font-sans supports-[height:100dvh]:min-h-dvh"
	>
		<LogoFull
			:aria-hidden="false"
			aria-label="Apropos.jobs"
			class="h-[29px] w-[250px] max-w-full sm:w-[350px]"
		/>
		<div class="flex w-full flex-col items-center gap-12">
			<div
				class="flex size-[120px] shrink-0 items-center justify-center rounded-full bg-blue-grey-100 text-slate-700 shadow-md"
				aria-hidden="true"
			>
				<IconSuitcase v-if="job" :size="64" :stroke-width="1.5" />
				<img
					v-else
					src="/images/errors/file-search.svg"
					alt=""
					class="size-16"
				/>
			</div>
			<div class="flex max-w-3xl flex-col gap-3">
				<h1
					class="m-0 font-sans text-3xl font-semibold normal-case text-grey-1000 sm:text-4xl"
				>
					{{ copy.title }}
				</h1>
				<p class="m-0 text-base font-normal text-grey-700">
					{{ copy.message }}
				</p>
			</div>
			<Button
				type="primary"
				class="bg-grey-1000 focus-visible:ring-2 focus-visible:ring-grey-700 focus-visible:ring-offset-2"
				@click="$router.push(recoveryDestination)"
				>{{ recoveryLabel }}</Button
			>
		</div>
	</section>
</template>

<script>
import { LogoFull } from '~/components/Logo'
import IconSuitcase from '~/components/Icons/IconSuitcase'
import Button from '~/components/ui/common/Button'
import { getJobOfferRecoveryPath } from '~/utils/jobOfferRecovery'

const fallbackCopy = {
	job: {
		title: 'This job is no longer available',
		message:
			'This position has been filled or closed and is no longer accepting applications.',
		action: 'View open roles'
	},
	page: {
		title: 'Page not found',
		message:
			'The page you’re looking for doesn’t exist or may have been moved.',
		action: 'Go to homepage'
	}
}

export default {
	name: 'NotFoundPage',
	components: { LogoFull, IconSuitcase, Button },
	props: {
		job: { type: Boolean, default: false },
		mode: { type: String, default: 'applicant' }
	},
	computed: {
		recoversToDashboard() {
			return this.job && this.mode === 'organization'
		},
		recoveryLabel() {
			if (!this.recoversToDashboard) return this.copy.action

			const key = 'general.go-to-dashboard'
			const translated = this.$t(key)
			return translated && translated !== key
				? translated
				: 'Go to dashboard'
		},
		recoveryDestination() {
			if (!this.job) return '/'

			return this.$store?.getters['user/loggedIn']
				? getJobOfferRecoveryPath(this.mode)
				: {
						path: '/auth/login',
						query: { redirect: '/job-offer/not-found?recover=1' }
				  }
		},
		copy() {
			const kind = this.job ? 'job' : 'page'
			return Object.fromEntries(
				Object.entries(fallbackCopy[kind]).map(([field, fallback]) => {
					const key = `error.not-found.${kind}.${field}`
					const translated = this.$t(key)
					return [
						field,
						translated && translated !== key ? translated : fallback
					]
				})
			)
		}
	}
}
</script>
